/**
 * Takes a DOM node and returns a unique CSS selector representing that node and its place in the
 * DOM. Taken from the following article:
 * @see
 * https://web.dev/debug-web-vitals-in-the-field/#usage-with-the-web-vitals-javascript-library
 * @param  {HTMLElement} node - DOM node
 * @param  {Number} maxLen - Help prevent the data limit for sendBeacon or XHR from being reached.
 * @return {String} - A CSS selector representing that node and its place in the DOM
 */
const getNodeCSSPath = (node, maxLen = 250) => {
  let sel = '';

  try {
    while (node && node.nodeType !== 9) {
      const part = node.id
        ? `#${node.id}`
        : node.nodeName.toLowerCase() + (
          (node.className && node.className.length)
            ? `.${Array.from(node.classList.values()).join('.')}`
            : ''
        );

      if (sel.length + part.length > maxLen - 1) {
        return sel || part;
      }

      sel = sel ? `${part} > ${sel}` : part;

      if (node.id) {
        break;
      }

      node = node.parentNode;
    }
  } catch (err) { /* Do nothing... */ }

  return sel;
};

export default getNodeCSSPath;
